import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { AbstractViewFC, DetailedViewFC } from "@project-rouge/rg-three";
import { memo, Suspense } from "react";
import { EditorTools } from "./index35.js";
import { BuildingFloorLines } from "./index44.js";
import { RotatingEnvironment } from "./index198.js";
import { useReflectiveMaterial } from "./index199.js";
const FeWorldEditor = memo(({
  abstract,
  visibility,
  layers,
  readonly,
  floorLines,
  obj,
  skyUrl,
  ...editorToolProps
}) => {
  useReflectiveMaterial(layers);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    !!skyUrl && /* @__PURE__ */ jsx(Suspense, { children: /* @__PURE__ */ jsx(RotatingEnvironment, { url: skyUrl }) }),
    floorLines && /* @__PURE__ */ jsx(BuildingFloorLines, { obj }),
    abstract && /* @__PURE__ */ jsx(AbstractViewFC, { obj }),
    !abstract && /* @__PURE__ */ jsx(
      DetailedViewFC,
      {
        obj,
        visibility,
        layers
      }
    ),
    !readonly && /* @__PURE__ */ jsx(
      EditorTools,
      {
        obj,
        visibility,
        ...editorToolProps
      }
    )
  ] });
});
FeWorldEditor.displayName = "FeWorldEditor";
export {
  FeWorldEditor
};
//# sourceMappingURL=index112.js.map
